"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandBusPortName = expandBusPortName;
exports.isPlausibleNetName = isPlausibleNetName;
exports.normalizePortOccurrences = normalizePortOccurrences;
function expandBusPortName(busPortName) {
    const match = busPortName.match(/^(.+)\[(\d+)(?:\.\.|:)(\d+)\]$/);
    if (!match) {
        return [];
    }
    const start = parseInt(match[2], 10);
    const end = parseInt(match[3], 10);
    const step = end >= start ? 1 : -1;
    const result = [];
    for (let index = start; step > 0 ? index <= end : index >= end; index += step) {
        result.push({ name: `${match[1]}${index}`, index });
    }
    return result;
}
function isPlausibleNetName(value) {
    return value !== undefined && /^[A-Za-z0-9_+.\-#:[\]/]+$/.test(value) && /[A-Za-z0-9]/.test(value);
}
function normalizedName(value) {
    return String(value).toUpperCase();
}
function normalizePortOccurrences(portOccurrences) {
    const bases = portOccurrences.filter((occurrence) => occurrence.RefBusMemberName === '');
    const ownersByMemberName = new Map();
    for (const base of bases) {
        for (const member of expandBusPortName(String(base.RefPortName))) {
            const key = normalizedName(member.name);
            const owners = ownersByMemberName.get(key) ?? [];
            owners.push(base);
            ownersByMemberName.set(key, owners);
        }
    }
    const diagnostics = [];
    const normalized = portOccurrences.map((occurrence, ordinal) => {
        if (occurrence.RefBusMemberName === '') {
            return occurrence;
        }
        const owners = ownersByMemberName.get(normalizedName(occurrence.RefBusMemberName)) ?? [];
        if (owners.length === 1) {
            return { ...occurrence, RefKey: owners[0].RefKey };
        }
        if (owners.length > 1) {
            diagnostics.push({
                memberName: occurrence.RefBusMemberName,
                candidateRefKeys: owners.map((owner) => String(owner.RefKey)),
            });
            return { ...occurrence, KeyType: 'AmbiguousPortMember', RefKey: `@orphan:${ordinal}` };
        }
        return occurrence;
    });
    return { portOccurrences: normalized, diagnostics };
}
//# sourceMappingURL=portOccurrenceNormalization.js.map